// extracted by mini-css-extract-plugin
export default {"list":"DeviceTwin_list__hKJ41","container":"DeviceTwin_container__0AKMl","row":"DeviceTwin_row__UjUDD","label":"DeviceTwin_label__t81gN","value":"DeviceTwin_value__JroDe"};